module.exports = __webpack_public_path__ + "img/second.2e7135c4.jpg";